<template>
  <div class="login-form" >
    <el-card class="login_card" >
      <p align="middle" class="Login_header">Sign in to Inside Insight</p>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
        <el-row style="margin-bottom: 1rem;">
          <el-col :span="20">
            <el-form-item class="label_feilds" label="User ID" prop="email">
              <el-input  type="email" v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item  class="label_feilds" label="Password" prop="password">
              <el-input  type="password" v-model="form.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>
        <div align="center">
          <el-button class="submit_btn" @click="onSubmit()" :autofocus="false" :loading="loader">Submit</el-button>
        </div>
    </el-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Signin',
  data () {
    var validateEmail = (rule, value, callback) => {
      var atpos = value.indexOf('@')
      var dotpos = value.lastIndexOf('.')
      if (!value) {
        callback(new Error('Enter Email ID'))
      } else if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= value.length) {
        callback(new Error('Please input correct Email Id'))
      }
      callback()
    }
    var validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Enter password'))
      }
      callback()
    }
    return {
      form: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { validator: validateEmail, trigger: 'change' }
        ],
        password: [
          { validator: validatePassword, trigger: 'change' }
        ]
      },
      loader: false
    }
  },
  computed: {
    ...mapGetters({
      getUserID: 'auth/getUserID',
      getSingleUser: 'Survey/getSingleUser'
    })
  },
  methods: {
    ...mapActions({
      Login: 'auth/Login',
      fetchSingleUser: 'Survey/fetchSingleUser'
    }),
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loader = true
          this.Login({
            email: this.form.email,
            password: this.form.password
          })
        }
      })
    }
  },
  watch: {
    getUserID (value) {
      if (value === 'Error') {
        this.$message.error('Unauthorized User')
      }
      this.loader = false
    }
  }
}
</script>
<style>
.Login_header {
  font-size: 2rem;
  color: white;

}
.login-form {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    background: url('../../assets/background_login8.png') no-repeat center center fixed;
    background-size: cover;
  }
 .ii-logo{
    width: 10em;
    margin: 5px auto;
    display: block;
  }
  .el-card.login_card {
    height: 350px;
    width: 40%;
    align-self: center;
    background-color: rgba(0, 0, 0, 0.4);
    border: 0px solid #030304;
  }

  .client-logo {
    display: block;
    margin: 0 auto;
  }
  #hint {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.289);
  }
  .el-button--text{
    text-align: right;
  }
  .input {
    color: white;
    font-size: 18px;
  }
  .label_feilds {
    margin-bottom: 20px;
    color: white;

  }
  .input_feilds {
    border: 1px solid white;
    background-color: rgba(0, 0, 0, 0.5);
    height: 2rem;
    width: 100%;
    color: white;
    padding: 5px;
    border-radius: 7px;
  }
  .el-button.is-loading:before {
    pointer-events: none;
    content: '';
    position: absolute;
    left: -1px;
    top: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: inherit;
    background-color: rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/Signin/index.vue